import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../../Features/User/userSlice";
import { toastError, toastSuccess, userUploadAvatar } from "../../api/services";
import "./DropdownMenu.css";

const MyAccountDropdown = ({ user, logout }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const [fileUpload, setFileUpload] = useState(false);
  const [uploading, setUploading] = useState(false);
  const ref = useRef();
  const fileInputRef = useRef(null);
  const location = useLocation();

  const isActive = (path) => (location.pathname === path ? "active" : "");

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      toastError("Only JPG/PNG images are allowed");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toastError("File too large (max 5MB)");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("userId", user?.id);
    formData.append("avatar", file);

    try {
      const res = await userUploadAvatar(formData);
      if (res?.data?.success) {
        dispatch(setUser(res.data.data));
        toastSuccess(res.data.message || "Avatar updated");
      } else {
        toastError(res.data?.message || "Upload failed");
      }
    } catch (err) {
      console.error("Upload error:", err);
      toastError(err.response?.data?.message || "Server error");
    } finally {
      setUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const triggerFileUpload = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      <li
        ref={ref}
        className={`dropdown-a dd my-account ${open ? "active" : ""}`}
        onClick={() => setOpen(!open)}
      >
        <div
          className="avatar-info"
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <div
            className="avatar-wrapper"
            onClick={triggerFileUpload}
            style={{ cursor: "pointer", position: "relative" }}
          >
            {user?.avatar ? (
              <img
                src={user.avatar}
                alt="avatar"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <i
                className="far fa-user-circle"
                style={{ fontSize: "40px" }}
              ></i>
            )}
          </div>
          <span>
            <div className="hello">Hello!</div>
            <div>{user?.name || "Guest"}</div>
          </span>
        </div>

        {/* Dropdown menu */}
        {open && (
          <ul className="dropdown">
            <li>
              <Link to="" onClick={() => setFileUpload(true)}>
                <i className="fa fa-user"></i> Upload Profile
              </Link>
            </li>
            <li>
              <Link to="/order" className={isActive("/order")}>
                <i className="fas fa-shopping-cart"></i> My Order
              </Link>
            </li>

            <li>
              <Link to="/user-profile" className={isActive("/user-profile")}>
                <i className="fa fa-user"></i> Profile
              </Link>
            </li>
            <li>
              <Link to="/my-address" className={isActive("/my-address")}>
                <i className="fas fa-users"></i> Address
              </Link>
            </li>
            <li>
              <Link to="/user-delete" className={isActive("/user-delete")}>
                <i className="fas fa-comments"></i> Delete Account
              </Link>
            </li>
            <li>
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  logout();
                }}
              >
                <i className="fas fa-sign-out-alt"></i> Logout
              </Link>
            </li>
          </ul>
        )}
      </li>
      {fileUpload && (
        <div className="modal-overlay">
          <div className="modal-container modal-sm">
            <div className="modal-content-custom">
              <div className="modal-header-custom">
                <h4>Upload Profile</h4>
                <button
                  type="button"
                  className="close-btn"
                  onClick={() => setFileUpload(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body-custom">
                
                {uploading && (
                  <div
                    className="upload-spinner"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(0,0,0,0.5)",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i className="fas fa-spinner fa-pulse"></i>
                  </div>
                )}
                <div
                  className="avatar-wrapper"
                  onClick={triggerFileUpload}
                  style={{ cursor: "pointer", position: "relative" }}
                >
                  <div className="avatar-wrapper-border">
                    {user?.avatar ? (
                      <img
                        src={user.avatar}
                        alt="avatar"
                        style={{
                          width: "200px",
                          height: "100%",
                          borderRadius: "5%",
                          objectFit: "cover",
                          padding: "5px",
                        }}
                      />
                    ) : (
                      <i
                        className="far fa-user-circle"
                        style={{
                          fontSize: "40px",
                          width: "200px",
                          height: "100%",
                          borderRadius: "5%",
                          objectFit: "cover",
                          justifyContent: "center",
                          display: "flex",
                          padding: "16px",
                        }}
                      ></i>
                    )}
                  </div>
                </div>
                <input
                  type="file"
                  ref={fileInputRef}
                  accept="image/jpeg,image/png,image/jpg"
                  onChange={handleAvatarChange}
                  style={{ display: "none" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MyAccountDropdown;
